<template>
  <div id="food-list" v-on:keyup.ctrl.alt.39="setDate(1)" v-on:keyup.ctrl.alt.37="setDate(-1)"
    v-on:keyup.ctrl.alt.83="uploadS3" v-on:keyup.ctrl.alt.38="scrollToTop">
    <!-- <div class="food-list-introduce" v-if="selectRestaurant === null">
      로그인 해주세요
    </div> -->
    <div v-if="selectRestaurant !== null">
      <div id="food-list-controlrs">
        <div id="food-list-controlrs-date">
          날짜 :
          <v-btn type="submit2" v-on:click="goToday" icon color="blue darken-3">
            <v-icon>today</v-icon>
          </v-btn>
          <v-btn v-on:click="setDate(-1)" icon dark color="blue darken-3">
            <v-icon>chevron_left</v-icon>
          </v-btn>
          <input type="date" name id v-on:change="getData()" v-model="uploadDate" />
          <v-btn v-on:click="setDate(1)" icon dark color="blue darken-3">
            <v-icon>chevron_right</v-icon>
          </v-btn>
          <label for>({{ uploadDay }}요일)</label>
        </div>
        <div>
          <v-btn type="submit2" v-on:click="uploadS3" dark color="blue darken-3">저장</v-btn>
          <v-btn type="reset" v-on:click="resetData" color="pink lighten-5">리셋</v-btn>
          <v-btn v-if="selectRestaurant.parser == 1" type="reset" v-on:click="parsingOn"
            color="green lighten-5">긁어오기시작</v-btn>
        </div>
      </div>
      <div id="food-list-templete-log">
        <label for="log">로그 : {{ logs }}</label>
      </div>
      <br />
      <div id="food-list-templete-log">
        홈페이지
        <a target="_blank" :href="selectRestaurant.homepage">{{ selectRestaurant.homepage }}</a>
      </div>
      <br />
      <div id="food-list-templete-log">
        데이터
        <a target="_blank" :href="getDataOriginUrl">{{ getDataOriginUrl }}</a>
      </div>
      <div id="food-list-templete-log">
        이전 데이터
        <a target="_blank" :href="getDataOldOriginUrl">{{ getDataOldOriginUrl }}</a>
      </div>
      <div id="food-list-categories">
        <food-category v-for="meal in mealList" :key="meal.category" :meal="meal"></food-category>
      </div>
      <v-divider></v-divider>
      <div v-if="mealList" id="food-list-controlrs">
        <div id="food-list-controlrs-date">
          날짜 :
          <v-btn type="submit2" v-on:click="goToday" icon color="pink lighten-5">
            <v-icon>today</v-icon>
          </v-btn>
          <v-btn v-on:click="setDate(-1)" icon dark color="blue darken-3">
            <v-icon>chevron_left</v-icon>
          </v-btn>
          <input type="date" name id v-on:change="getData()" v-model="uploadDate" />
          <v-btn v-on:click="setDate(1)" icon dark color="blue darken-3">
            <v-icon>chevron_right</v-icon>
          </v-btn>
          <label for>({{ uploadDay }}요일)</label>
        </div>
        <div class="food-list-bottom-controlrs">
          <v-btn type="submit2" v-on:click="uploadS3" dark color="blue darken-3">저장</v-btn>
          <v-btn type="reset" v-on:click="resetData" color="pink lighten-5">리셋</v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FoodCategory from '@/components/FoodCategory.vue';
import FoodTemplate from '@/utils/FoodTemplate';

import { ApiService } from '@/services/GuneApiService.js';
import { S3Service } from '@/services/S3ApiService.js';
import format from 'date-fns/format';
import addDays from 'date-fns/add_days';
import ko from 'date-fns/locale/ko';
import parser from '@/services/parser.js';
import store from '@/store.js';

export default {
  name: 'FoodList',
  store,
  components: {
    FoodCategory,
  },
  data: function () {
    return {
      mealList: FoodTemplate.DEFAULT_TEMPLETE,
      uploadDB: '',
      uploadDate: format(new Date(), 'YYYY-MM-DD'),
      templeteUrl: '',
      logs: '',
    };
  },
  watch: {
    selectRestaurant: function () {
      this.goToday();
      this.getData();
    },
  },
  computed: {
    selectRestaurant: function () {
      return this.$store.state.selectRestaurant;
    },
    yyyymmdd: function () {
      var rightNow = new Date();
      var res = rightNow
        .toISOString()
        .slice(0, 10)
        .replace(/-/g, '');
      return res;
    },
    uploadDay: function () {
      return format(this.uploadDate, 'ddd', { locale: ko });
    },
    templetes: function () {
      let templates = FoodTemplate.getTempletes();
      return templates;
    },
    getDataUrl: function () {
      let yyyymmdd = format(this.uploadDate, 'YYYYMMDD');
      if (this.selectRestaurant.is_fix) {
        yyyymmdd = '99999999';
      }
      let guneid =
        this.selectRestaurant.extid != undefined
          ? this.selectRestaurant.extid
          : this.selectRestaurant.gid;
      return `${guneid}/${yyyymmdd}`;
    },
    getDataOriginUrl: function () {
      return `http://data.gune.kr.s3.amazonaws.com/${this.getDataUrl}`;
    },
    getDataOldOriginUrl: function () {
      return `http://ddafoodlist.s3.amazonaws.com/${this.getDataUrl}`;
    },
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    setDate: function (dayOffset) {
      if (this.selectRestaurant === null || this.selectRestaurant.hasOwnProperty('gid') === false)
        return alert('식당을 선택해주세요');

      let newDate = addDays(format(this.uploadDate, 'YYYY-MM-DD'), dayOffset);
      this.uploadDate = format(newDate, 'YYYY-MM-DD');
      this.getData();
    },
    goToday: function () {
      this.uploadDate = format(new Date(), 'YYYY-MM-DD');
      this.getData();
    },
    // getHomePage: function() {
    //   return this.$store.state.selectRestaurant;
    // },
    getData: function () {
      if (
        (this.selectRestaurant === null || this.selectRestaurant.hasOwnProperty('gid') === false) &&
        this.getters.isAuthenticated === true
      )
        return alert('식당을 선택해주세요');

      var vm = this;
      let dataUrl = this.getDataUrl;

      S3Service()
        .get(dataUrl)
        .then(function (response) {
          vm.mealList = Object.assign([], vm.mealList, response.data.mealList);

          vm.logs = '데이터를 가져왔습니다';
        })
        .catch(function () {
          // alert(error);
          vm.resetData();
          let templete = vm.selectRestaurant.template;
          // if (templete === undefined) return;
          let initMealList = JSON.parse(JSON.stringify(templete));


          vm.mealList = initMealList;

          vm.logs = '해당일자 데이터가 없습니다';
        });
    },
    uploadS3: function () {
      if (this.selectRestaurant === null) return alert('식당을 선택해주세요');

      let id = format(this.uploadDate, 'YYYYMMDD');
      if (this.selectRestaurant.is_fix) {
        id = '99999999';
      }
      let foodmenu = this.mealList;

      ApiService()
        .post('/foodmenu', {
          menuid: id,
          menu: foodmenu,
          gid: this.selectRestaurant.gid,
          extid: this.selectRestaurant.extid,
        })
        .then((res) => {
          alert(res.data);
        })
        .catch(function (err) {
          alert(err);
        });
    },
    parsingOn: function () {
      if (this.selectRestaurant.parse === 0) return;
      parser(this.selectRestaurant, this.uploadDate);
    },
    resetData: function () {
      let templete = this.selectRestaurant.template;
      // if (templete === undefined) return;
      let initMealList = JSON.parse(JSON.stringify(templete));
      this.mealList = initMealList;
    },
    setTemeplete: function (templeteId) {
      this.resetData();

      let templete = FoodTemplate.getTemplete(templeteId);
      // this.uploadDB = templete.db;
      this.mealList = JSON.parse(JSON.stringify(templete.data));
      this.templeteUrl = templete.url;

      this.getData();
    },
  },
};
</script>

<style scoped>
#food-list {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-left: 50px;
  width: 100%;
}

.food-list-introduce {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

#food-list-controlrs {
  display: flex;
  flex-direction: row;
  /* padding: 1em; */
  /* position: fixed; */
  /* float: left; */
}

#food-list-bottom-controlrs {
  display: inline;
}

#food-list-controlrs-date {
  padding-right: 3em;
  /* float: left; */
}

#food-list-templete-section {
  margin-top: 1em;
  margin-bottom: 1em;
}

.food-list-templete {
  margin-right: 1em;
}

#food-list-templete-log {
  float: left;
}

#food-list-categories {
  display: flex;
  flex-direction: column;
  width: 100%;
  /* overflow-y: auto; */
}
</style>
